//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import TranslatorService from '@/services/translator'

//
import PurchaseQuotationModel from '@/models/Purchase/PchPurchaseQuotation'
import fields from './fields'

//
export default {
    name: 'purchase-quotation-create',
    components: {
        ModelForm,
    },
    computed: {
        /**
         * @description
         */
        formProps() {
            return {
                fields,
            }
        },
    },
    data() {
        return {
            formData: {},
        }
    },
    methods: {
        /**
         * @description
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         * @description
         */
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
        }),

        /**
         * @description
         *
         */
        create(model) {
            model
                .toCreate()
                .save()
                .finally(this.$refs.form.setWait)
                .then(this.success)
                .then(this.redirect)
                .catch(this.error)
        },

        /**
         * @description
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(PurchaseQuotationModel, error.response.data)
            )
        },

        /**
         * @description
         *
         */
        redirect() {
            this.$router.push({ name: 'purchase-quotation-list' })
        },

        /**
         * @description
         *
         */
        reset() {
            this.formData = new PurchaseQuotationModel().reset()
        },

        /**
         * @description
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },

        /**
         * @description
         *
         */
        success() {
            this.setSuccessSnackbar('Cotización de compra agregada.')
        },
    },
    beforeMount() {
        this.setTitleTopBar('Crear cotización de compra')
    },
    mounted() {
        this.reset()
    },
}
